module.exports = __webpack_public_path__ + "static/media/step3.e53b818f.png";